module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.981fd43e.jpg";